import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import isTouchDevice from "@insite/client-framework/Common/Utilities/isTouchDevice";
import parseImageUrl from "@insite/client-framework/Common/Utilities/parseImageUrl";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getBrandsDataView } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import loadBrands from "@insite/client-framework/Store/Data/Brands/Handlers/LoadBrands";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import FlexItem, { FlexItemProps } from "@insite/content-library/Widgets/Brand/FlexItem";
import FlexWrapContainer, { FlexWrapContainerProps } from "@insite/content-library/Widgets/Brand/FlexWrapContainer";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Icon from "@insite/mobius/Icon";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import ArrowRightLongIcon from "@tCentro/Icons/ArrowRightLongIcon";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import { ProductCarouselStyles } from "@tCentro/Widgets/Brand/CENBrandFeaturedProductCarousal";
import useEmblaCarousel from "embla-carousel-react";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

interface SlideModel {
    fields: {
        slideTitle: string;
        image: string;
        heading: string;
        subheading: string;
        BrandURL: string;
    };
}
const enum fields {
    title = "title",

    maximumNumberOfBrandsPerRow = "maximumNumberOfBrandsPerRow",
    maximumBrandImageHeight = "maximumBrandImageHeight",
    maxNumberOfColumns = "maxNumberOfColumns",
    btnLabel = "btnLabel",
    btnlink = "btnlink",
    slides = "slides",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.maxNumberOfColumns]: number;
        [fields.maximumNumberOfBrandsPerRow]: string;
        [fields.maximumBrandImageHeight]: number;
        [fields.btnLabel]: string;
        [fields.btnlink]: LinkFieldValue;
        [fields.slides]: SlideModel[];
    };
}

type Props = OwnProps & ThemeProps<BaseTheme> & HasShellContext;

export interface BrandListStyles {
    container?: InjectableCss;
    imageContainer?: FlexWrapContainerProps;
    imageItem?: FlexItemProps;
    link?: LinkProps;
    errorMessageText?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    skipCarouselButton?: SkipNavStyles;
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonPresentationProps;
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    carouselbrandListtyles?: ProductCarouselStyles;
    customproducttilewrapper?: InjectableCss;
    wrapper?: InjectableCss;
    carouselBrandWrapper?: InjectableCss;
    image?: LazyImageProps;
    btnlinkStyles?: InjectableCss;
    btnContainerDesktopStyles?: InjectableCss;
    btnlinkDesktopStyles?: InjectableCss;
    rightArrowIconStyle?: InjectableCss;
    aboveSmStyles?: InjectableCss;
}

export const listStyles: BrandListStyles = {
    aboveSmStyles: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 56px;
                    `,
                    css`
                        margin-bottom: 56px;
                    `,
                    css`
                        margin-bottom: 40px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    errorMessageText: {
        color: "danger",
        css: css`
            margin-top: 20px;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            margin-bottom: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 14px;
                        font-family: ${TYPOGRAPHY.fontFamily.title};
                        font-size: ${TYPOGRAPHY.size.largest};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        line-height: 32px;
                        text-align: left;
                    `,
                    css`
                        margin-bottom: 14px;
                        font-family: ${TYPOGRAPHY.fontFamily.title};
                        font-size: ${TYPOGRAPHY.size.largest};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        line-height: 32px;
                        text-align: left;
                    `,
                    css`
                        font-family: ${TYPOGRAPHY.fontFamily.title};
                        font-size: ${TYPOGRAPHY.size.largest};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        line-height: 32px;
                        text-align: left;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    container: {
        css: css`
            margin: 20px 0 20px 0;
            text-align: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0 1rem;
                        `,
                        null,
                        null,
                        css`
                            padding: 0 5rem;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    wrapper: {
        css: css`
            /* background-color: #ebebeb; */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                        margin-bottom: 0px;
                    `,
                    css`
                        flex-wrap: wrap;
                        margin-bottom: 0px;
                    `,
                    css`
                        /* max-width: 720px !important; */
                        flex-wrap: wrap;
                        margin-bottom: 0px;
                    `,
                    css`
                        /* max-width: 917px !important; */
                        padding: 0px;
                        flex-wrap: nowrap;
                    `,
                    css`
                        /* max-width: 1300px !important; */
                        flex-wrap: nowrap;
                        padding: 0px;
                    `,
                ])}
        `,
    },
    mainContainer: {
        gap: 0,
        css: css`
            position: relative;
        `,
    },
    prevArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            position: absolute;
            z-index: 1;
            top: 50%;
            transform: translateY(-50%);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 12.33% !important;
                        max-width: 12.33% !important;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            background: ${getColor("primary")};
            border-radius: 50%;
            position: relative;
            min-height: auto !important;
            width: 30px;
            height: 30px;
            /* span {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            } */
            svg {
                width: 22px;
                height: 30px;
                stroke: white;
                stroke-width: 4px;
            }
            &:focus {
                outline: none;
            }
        `,
    },
    nextArrowGridItem: {
        width: 1,
        align: "middle",

        css: css`
            position: absolute;
            z-index: 1;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 12.33% !important;
                        max-width: 12.33% !important;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    nextArrowButton: {
        // variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            background: ${getColor("primary")};
            border-radius: 50%;
            position: relative;
            min-height: auto !important;
            width: 30px;
            height: 30px;
            /* span { */
            /* width: 100%;
                height: 100%;
                border-radius: 50%;
            } */
            svg {
                width: 22px;
                height: 30px;
                stroke: white;
                stroke-width: 4px;
                position: absolute;
                right: 0px;
            }
            &:focus {
                outline: none;
            }
            &:hover {
                background: ${getColor("primary")};
            }
        `,
    },
    link: {
        css: css`
            width: 100%;
            max-width: 100% !important;
            align-items: center;
            justify-content: center;
            display: flex;
            height: 100%;
        `,
    },
    carouselGridItem: {
        width: 10,
        css: css`
            &:after {
                content: "";
                position: absolute;
                z-index: 1;
                width: 100px;
                box-sizing: border-box;
                right: 0px;
                height: 100%;
                background: linear-gradient(270deg, rgba(243, 247, 244, 1) 0%, rgba(243, 247, 244, 0) 100%);
            }
            &:before {
                content: "";
                position: absolute;
                z-index: 1;
                width: 20px;
                box-sizing: border-box;
                right: -20px;
                height: 100%;
                background: linear-gradient(-450deg, rgba(243, 247, 244, 1) 0%, rgba(243, 247, 244, 0) 100%);
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        &:after {
                            display: none;
                        }
                        &:before {
                            display: none;
                        }
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        &:after {
                            display: none;
                        }
                        &:before {
                            display: none;
                        }
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                ])}
        `,
    },
    carouselWrapper: {
        css: css`
            width: 100%;
            position: relative;
        `,
    },
    carouselContainer: {
        css: css`
            overflow: hidden;
            /* padding: 30px 7px 13px; */
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
            gap: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                        justify-content: center;
                        row-gap: 16px;
                        column-gap: 8px;
                    `,
                    css`
                        flex-wrap: wrap;
                        row-gap: 16px;
                        column-gap: 8px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    carouselSlide: {
        css: css`
            padding: 0;
            position: relative;
            flex: 0 0 auto;
            max-width: 185px;
            width: 100%;
            margin-top: 10px;
            /* padding-right: 12px;
            padding-left: 10px; */
            margin-bottom: 10px;
            margin-left: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 50%;
                        max-width: 50%;
                        flex: 1 1 45%;
                        margin-left: 0px;
                        margin-top: 0px;
                        margin-bottom: 0px;
                    `,
                    css`
                        flex-basis: 50%;
                        max-width: 50%;
                        flex: 1 1 45%;
                        margin-left: 0px;
                        margin-top: 0px;
                        margin-bottom: 0px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    carouselSlideInner: {
        css: css`
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            /* cursor: pointer; */
            position: relative;
            justify-content: flex-start;
            background-color: white;
        `,
    },
    carouselBrandWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            position: relative;
            background-color: #fff;
            box-shadow: 0px 4.96px 9.92px 0px #2625253d;
        `,
    },
    btnlinkStyles: {
        css: css`
            font-size: ${TYPOGRAPHY.size.large};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            font-family: "Poppins";
        `,
    },
    imageContainer: {
        css: css`
            min-height: 131px;
            width: 100%;
            span {
                height: 100%;
                width: 100%;
            }
            div[class^="LazyImageStyle"] {
                width: 100%;
            }
            span[class^="IconWrapper"] {
                width: 100%;
                justify-content: center;
            }
        `,
    },
    btnContainerDesktopStyles: {
        css: css`
            align-self: center;
            display: flex;
            justify-content: space-between;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        align-self: center;
                        margin-top: 24px;
                        display: flex;
                        justify-content: center;
                    `,
                    css`
                        align-self: center;
                        margin-top: 24px;
                        display: flex;
                        justify-content: center;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    btnlinkDesktopStyles: {
        css: css`
            font-size: ${TYPOGRAPHY.size.large};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            font-family: "Poppins";
        `,
    },
    rightArrowIconStyle: {
        css: css`
            height: 11.25px;
            width: 18px;
            margin-left: 5px;
            svg {
                height: 11.25px;
                width: 18px;
                > path {
                    fill: ${getColor("text.link")};
                }
            }
        `,
    },
};

const styles = listStyles;

const BrandGalleryCustom: React.FC<Props> = ({ fields, shellContext, theme }) => {
    const afterCarousel = React.createRef<HTMLSpanElement>();
    const [emblaRef, embla] = useEmblaCarousel();
    const [windowResizeTime, setWindowResizeTime] = React.useState(0);
    const [canScrollPrev, setCanScrollPrev] = React.useState(false);
    const [canScrollNext, setCanScrollNext] = React.useState(false);
    const [activeScroll, setActiveScroll] = React.useState(false);

    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    const getSlidesToScroll = React.useCallback(() => {
        const maxNumberOfColumns = fields.maxNumberOfColumns || 6;
        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let localSlidesToScroll: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 2;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 2;
        } else if (window.innerWidth < theme.breakpoints.values[4]) {
            localSlidesToScroll = 4;
        } else if (window.innerWidth < theme.breakpoints.values[5]) {
            localSlidesToScroll = 4;
        } else {
            localSlidesToScroll = 4;
        }
        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    }, [fields.maxNumberOfColumns]);

    const [slidesToScroll, setSlidesToScroll] = React.useState(getSlidesToScroll());

    const getDraggable = () => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    };

    const [draggable, setDraggable] = React.useState(getDraggable());

    const onWindowResize = () => {
        setWindowResizeTime(Date.now());
    };

    React.useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();
        setSlidesToScroll(newSlidesToScroll);

        const newDraggable = getDraggable();
        setDraggable(newDraggable);
    }, [fields.maxNumberOfColumns, windowResizeTime]);

    React.useEffect(() => {
        if (!embla) {
            return;
        }
        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);
    React.useEffect(() => {
        onWindowResize();
    }, []);

    React.useEffect(() => {
        if (!embla || !fields.slides || fields.slides.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll,
            watchDrag: draggable,
            loop: true,
        });
        setCanScroll();
    }, [embla, slidesToScroll, draggable, fields.slides, activeScroll]);

    // const desktop = parseInt(fields.maximumNumberOfBrandsPerRow, 10);
    // const tablet = Math.ceil(desktop / 2);
    // const mobile = Math.ceil(tablet / 2);

    const imgProps = {
        style: {
            width: "auto",
            maxWidth: "100%",
            maxHeight: `${fields.maximumBrandImageHeight}px`,
            padding: "5px",
        },
    };

    // const focusFunction = () => {
    //     const elementToFocus = document.getElementById("collapseButton");
    //     if (elementToFocus) {
    //         elementToFocus.focus();
    //     } else {
    //         document.getElementById("expandButton")?.focus();
    //     }
    // };

    if (!fields.slides) {
        return null;
    }
    return (
        <>
            <Hidden below="md">
                <StyledWrapper {...styles.wrapper} onMouseMove={() => setActiveScroll(true)}>
                    <StyledWrapper {...styles.customproducttilewrapper}>
                        <StyledWrapper {...styles.btnContainerDesktopStyles}>
                            <Typography {...styles.titleText}>{fields.title}</Typography>

                            <Link href={fields.btnlink.value} {...styles.btnlinkDesktopStyles}>
                                {fields.btnLabel}
                                <Icon src={ArrowRightLongIcon} {...styles.rightArrowIconStyle}></Icon>
                            </Link>
                        </StyledWrapper>
                        <GridContainer {...styles.mainContainer} data-test-selector="productCarousel">
                            {/* <GridItem {...styles.prevArrowGridItem}>
                                {brandList.length > slidesToScroll && canScrollPrev && (
                                    <Button
                                        {...styles.prevArrowButton}
                                        onClick={() => embla && embla.scrollPrev()}
                                        disabled={!canScrollPrev}
                                        data-test-selector="prevBtn"
                                    >
                                        <ButtonIcon src={ChevronLeft} />
                                    </Button>
                                )}
                            </GridItem> */}
                            <GridItem {...styles.carouselGridItem}>
                                <StyledWrapper {...styles.carouselWrapper}>
                                    <StyledWrapper {...styles.carouselContainer} ref={emblaRef}>
                                        <StyledWrapper {...styles.carouselSlidesContainer} data-test-selector="slides">
                                            {fields.slides?.map(brand => (
                                                <StyledWrapper
                                                    {...styles.carouselSlide}
                                                    key={brand.fields.heading}
                                                    style={{ width: `calc(100% / ${slidesToScroll})` }}
                                                >
                                                    <StyledWrapper
                                                        {...styles.carouselSlideInner}
                                                        id={`product_${brand.fields.heading}`}
                                                        data-test-selector="brandContainer"
                                                        className="related-brandTile"
                                                    >
                                                        <StyledWrapper {...styles.carouselBrandWrapper}>
                                                            <Clickable href={brand.fields.BrandURL} {...styles.link}>
                                                                <LazyImage
                                                                    imgProps={imgProps}
                                                                    {...styles.image}
                                                                    src={brand.fields.image}
                                                                    altText={brand.fields.heading}
                                                                />
                                                            </Clickable>
                                                        </StyledWrapper>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            ))}
                                        </StyledWrapper>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.nextArrowGridItem}>
                                {fields.slides.length > slidesToScroll && canScrollNext && (
                                    <Button
                                        {...styles.nextArrowButton}
                                        onClick={() => embla && embla.scrollNext()}
                                        disabled={!canScrollNext}
                                        data-test-selector="nextBtn"
                                    >
                                        <ButtonIcon src={ChevronRight} />
                                    </Button>
                                )}
                            </GridItem>
                        </GridContainer>
                    </StyledWrapper>

                    <span ref={afterCarousel} tabIndex={-1} />
                </StyledWrapper>
            </Hidden>
            <Hidden above="sm" {...styles.aboveSmStyles}>
                <StyledWrapper {...styles.wrapper}>
                    <SkipNav
                        text={translate("Skip Carousel")}
                        extendedStyles={styles.skipCarouselButton}
                        destination={afterCarousel}
                    />
                    <StyledWrapper {...styles.customproducttilewrapper}>
                        <GridContainer {...styles.mainContainer} data-test-selector="productCarousel">
                            <Typography {...styles.titleText}>{fields.title}</Typography>

                            <GridItem {...styles.carouselGridItem}>
                                <StyledWrapper {...styles.carouselWrapper}>
                                    <StyledWrapper {...styles.carouselSlidesContainer} data-test-selector="slides">
                                        {fields.slides.slice(0, 4)?.map(slide => (
                                            <StyledWrapper
                                                {...styles.carouselSlide}
                                                key={slide.fields.heading}
                                                style={{ width: `calc(100% / ${slidesToScroll})` }}
                                            >
                                                <StyledWrapper
                                                    {...styles.carouselSlideInner}
                                                    id={`product_${slide.fields.heading}`}
                                                    data-test-selector="productContainer"
                                                    className="related-productTile"
                                                >
                                                    <StyledWrapper {...styles.carouselBrandWrapper}>
                                                        <Clickable href={slide.fields.BrandURL} {...styles.link}>
                                                            <LazyImage
                                                                imgProps={imgProps}
                                                                {...styles.image}
                                                                src={parseImageUrl(slide.fields.image).url}
                                                                altText={slide.fields.heading}
                                                            />
                                                        </Clickable>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        ))}
                                    </StyledWrapper>
                                </StyledWrapper>
                            </GridItem>
                        </GridContainer>
                    </StyledWrapper>

                    <span ref={afterCarousel} tabIndex={-1} />
                </StyledWrapper>
                <StyledWrapper {...styles.btnContainerDesktopStyles}>
                    <Link href={fields.btnlink.value} {...styles.btnlinkDesktopStyles}>
                        {fields.btnLabel}
                        <Icon src={ArrowRightLongIcon} {...styles.rightArrowIconStyle}></Icon>
                    </Link>
                </StyledWrapper>
            </Hidden>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withIsInShell(withTheme(BrandGalleryCustom)),
    definition: {
        group: "Brands",
        icon: "image",
        displayName: "Brand Gallery Custom",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
            },

            {
                name: fields.maxNumberOfColumns,
                displayName: "Max Number Of Columns",
                editorTemplate: "IntegerField",
                min: 1,
                max: 6,
                defaultValue: 6,
                fieldType: "General",
                sortOrder: 8,
            },

            {
                name: fields.slides,
                editorTemplate: "ListField",
                getDisplay: ({ fields: { slideTitle } }) => slideTitle || "Slide",
                defaultValue: [],
                fieldType: "Contextual",
                fieldDefinitions: [
                    {
                        name: "image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        name: "heading",
                        editorTemplate: "TextField",
                        displayName: "Heading",
                        defaultValue: "",
                    },
                    {
                        name: "BrandURL",
                        editorTemplate: "TextField",
                        displayName: "Brand URL",
                        defaultValue: "",
                    },
                ],
            },
            {
                name: fields.maximumNumberOfBrandsPerRow,
                displayName: "Maximum brands per row",
                editorTemplate: "DropDownField",
                defaultValue: "6",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                ],
                fieldType: "Contextual",
                tooltip:
                    "Up to 6 brands can display per row. This number should be adjusted based on the number of brands you choose to display. For example, if you display 10 brands you likely want 5 to display per row. Logos will also stack responsively for smaller screen sizes.",
                tooltipPosition: "left",
            },
            {
                name: fields.maximumBrandImageHeight,
                displayName: "Maximum brand image height",
                editorTemplate: "IntegerField",
                defaultValue: 100,
                fieldType: "Contextual",
                tooltip:
                    "By default, images will scale to meet the width of the screen for the number of brands to display per row. The maximum height value can be used to scale brand logos to be smaller. Default value is 100 pixels.",
            },
            {
                name: fields.btnLabel,
                editorTemplate: "TextField",
                displayName: "Button Label",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.btnlink,
                displayName: "Button Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
